import React, { useEffect, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Input from 'b2b-ui-components-lib/lib/components/input';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import './planConfigurationForMPL.scss';
import { FORM_FIELDS, formSchema, getDefaultValue, getQOSState, validationKeysForQOS } from './formControl';
import { getFromSessionStorage, setInSessionStorage } from '../../../common/utils/app.utils';
import { AVAILABLE_BANDWIDTH, DEDICATED_FEASIBILITY_DATA, MODULE_ID } from '../../../home/common/constants/constants';
import { VPN_CONFIG } from 'common/constants/app.constants';
import { isFormValid } from '../../../common/utils/validator';
import PopupComponent from '../pop-up/popup.component';
import { prepareSpecModel, MEDIA_TYPES, isRFMedia } from './plan.service';
import ServicesDropdown from './servicesDropdown/servicesDropdown';
import {
  faOnDedicatedPlanConfigurationModalLoad,
  faOnDedicatedKamPlanConfigurationModalLoad,
  faOnDedicatedPlanConfigurationModalSubmit,
  faOnDedicatedKamPlanConfigurationModalSubmit
} from '../../../dedicated/services/analytics.service';

const PlanConfigurationForMPLS = ({
  open,
  close,
  updateDiConnectionData,
  setservicetype,
  changeIpAttributeType = () => {},
  checkLeadSatus,
  ipAttributeType,
  selectedPlan,
  commercialAttributes,
  leadDetails,
  dualLastMile,
  paramsValue,
  showOnlyOK = false,
  setServiceOption = () => {},
  selectedPrimaryMedia = {},
  setSelectedPrimaryMedia = () => {},
  primaryMediaOptions = [],
  feasibilityData = {}
}) => {
  const isSiteManualFeasible = feasibilityData && feasibilityData.feasibilityStatus === 'MANUAL_INTERVENTION_REQUIRED';
  const isSitePendingThirdParty = feasibilityData && feasibilityData.feasibilityStatus === 'PENDING_FOR_THIRD_PARTY';

  const [primaryForm, setPrimaryForm] = useState(formSchema);
  const [secondaryForm, setSecondaryForm] = useState(formSchema);
  const [isPrimaryActive, setIsPrimaryActive] = useState(true);
  const [isSecondaryActive, setIsSecondaryActive] = useState(false);
  const [isSecondaryVisible, setIsSecondaryVisible] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState({
    state: false,
    data: {}
  });
  const [showManageServices, setShowManageServices] = useState(false);
  const [defaultState, setDefaultState] = useState(formSchema);
  const [currentPlan, setCurrentPlan] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [isFormInitilaised, setIsFormInitilaised] = useState(false);
  const [primaryMedia, setPrimaryMedia] = useState(selectedPrimaryMedia || {});

  const toggleSelectPopUp = () => {
    setShowErrorPopup({ state: !showErrorPopup.state });
  };

  const onFieldBlur = (formElement, keyName, type) => {
    const { value, validator, errors: existingError } = formElement;
    let errors = [];
    if (typeof validator === 'function') {
      errors = validator(value);
    }
    if (type === 'secondary') {
      setSecondaryForm({
        ...secondaryForm,
        [keyName]: {
          ...secondaryForm[keyName],
          value,
          errors: errors.concat(existingError),
          touched: true
        }
      });
      return;
    }
    setPrimaryForm({
      ...primaryForm,
      [keyName]: {
        ...primaryForm[keyName],
        value,
        errors: errors.concat(existingError),
        touched: true
      }
    });
  };

  const onCPEChange = (selected) => {
    setPrimaryForm({
      ...primaryForm,
      cpeType: { ...primaryForm.cpeType, value: selected }
    });
  };

  const onPrimaryChange = (selected) => {
    if (selected.formKey === 'qos') {
      onQosChange(selected);
      return;
    }

    setPrimaryForm({
      ...primaryForm,
      [selected.formKey]: { ...primaryForm[selected.formKey], value: selected }
    });

    // E-ILL CUTOVER CHANGE -> ROUTING PROTOCOL SHOULD BE SAME FOR BOTH LINKS -> VPN PRODUCT
    if (selected?.formKey === FORM_FIELDS.ROUTING_PROTOCOL) {
      setSecondaryForm({
        ...secondaryForm,
        [selected.formKey]: {
          ...secondaryForm[selected.formKey],
          value: selected
        }
      });
    }
  };

  const onVPNTopologyChange = (selected, form, setForm) => {
    const vpnTopology = selected.displayName.split('&');
    const linkTopologyOptions = form.linkTopology.originalOptions.filter(({ displayName }) => {
      return vpnTopology.length > 1 ? displayName.includes(vpnTopology[0].trim()) || displayName.includes(vpnTopology[1].trim()) : displayName.includes(vpnTopology[0].trim());
    });
    setForm({
      ...form,
      linkTopology: {
        ...form.linkTopology,
        value: linkTopologyOptions[0],
        options: linkTopologyOptions
      },
      [selected.formKey]: { ...form[selected.formKey], value: selected }
    });
  };

  const onQosChange = (selectedOption, type) => {
    //  const form =  type === 'secondary' ? secondaryForm : primaryForm;
    //  const setForm = type === 'secondary' ? setSecondaryForm : setPrimaryForm;
    //  setForm(getQOSState(form, selectedOption));
    setPrimaryForm(getQOSState(primaryForm, selectedOption));
    setSecondaryForm(getQOSState(secondaryForm, selectedOption));
  };

  const onPrimaryChangeForInput = (value, key, type) => {
    value = value.trim();
    const portBandwidthValue = parseInt(primaryForm.portBandwidth.value.id.replace(' Mbps', ''));
    if (type === 'secondary') {
      setSecondaryForm({
        ...secondaryForm,
        [key]: {
          ...secondaryForm[key],
          errors: (secondaryForm[key].validator && secondaryForm[key].validator(value)) || [],
          value: value,
          touched: true
        }
      });
      return;
    }
    if (validationKeysForQOS.includes(key)) {
      const bandwidthSum = getSumOfInputBandwidths(key);

      if (+value >= portBandwidthValue) {
        setPrimaryForm({
          ...primaryForm,
          [key]: {
            ...primaryForm[key],
            errors: [`Value should be less than portbandwidth(${portBandwidthValue} Mbps)`],
            value: value,
            touched: true
          }
        });
      } else if (bandwidthSum + +value > portBandwidthValue) {
        setPrimaryForm({
          ...primaryForm,
          [key]: {
            ...primaryForm[key],
            errors: [`Total sum should not be greater than portbandwidth(${portBandwidthValue} Mbps)`],
            value: value,
            touched: true
          }
        });
      } else if (bandwidthSum + +value < portBandwidthValue && ['prt', 'pnrt', 'standard'].includes(key)) {
        setPrimaryForm({
          ...primaryForm,
          [key]: {
            ...primaryForm[key],
            errors: [`Total sum should be equal to portbandwidth(${portBandwidthValue} Mbps)`],
            value: value,
            touched: true
          }
        });
      } else if (bandwidthSum + +value <= 0) {
        setPrimaryForm({
          ...primaryForm,
          [key]: {
            ...primaryForm[key],
            errors: [`Total sum should not be less than 1 Mbps)`],
            value: value,
            touched: true
          }
        });
      } else if (isNaN(bandwidthSum + +value)) {
        setPrimaryForm({
          ...primaryForm,
          [key]: {
            ...primaryForm[key],
            errors: ['Invalid Bandwidth Sum'],
            value: value,
            touched: true
          }
        });
      } else if (validateQos(key, value, portBandwidthValue)) {
        const formData = { ...primaryForm };
        const secondaryFormData = { ...secondaryForm };
        formData[key].value = value;
        formData[key].touched = true;
        validationKeysForQOS.forEach((frmCntrolKey) => {
          formData[frmCntrolKey].errors = [];
          secondaryFormData[frmCntrolKey].value = frmCntrolKey === key ? value : formData[frmCntrolKey].value;
        });
        setPrimaryForm(formData);
        setSecondaryForm(secondaryFormData);
      }
      return;
    }
    setPrimaryForm({
      ...primaryForm,
      [key]: {
        ...primaryForm[key],
        errors: (primaryForm[key].validator && primaryForm[key].validator(value)) || [],
        value: value,
        touched: true
      }
    });
  };

  const getSumOfInputBandwidths = (key = null) => {
    let sum = 0;
    validationKeysForQOS.forEach((frmCntrolKey) => {
      if (frmCntrolKey !== key) {
        sum += +primaryForm[frmCntrolKey].value;
      }
    });
    return sum;
  };

  const validateQos = (key, value, portBandwidthValue = null) => {
    let check = true;
    const formData = { ...primaryForm };
    if (isNaN(+value)) {
      check = false;
      setPrimaryForm({
        ...primaryForm,
        [key]: {
          ...primaryForm[key],
          errors: ['Please enter only numeric characters'],
          value: value,
          touched: true
        }
      });
      return check;
    }
    validationKeysForQOS.forEach((frmCntrolKey) => {
      if (key !== frmCntrolKey && +primaryForm[frmCntrolKey].value >= portBandwidthValue) {
        check = false;
        formData[frmCntrolKey].errors = [`Value should be less than portbandwidth(${portBandwidthValue} Mbps)`];
        setPrimaryForm(formData);
        return;
      }
    });
    return check;
  };

  const onLastMileChange = (selected) => {
    setPrimaryForm({
      ...primaryForm,
      [selected.formKey]: { ...primaryForm[selected.formKey], value: selected },
      redundancy: {
        ...primaryForm.redundancy,
        value: primaryForm.redundancy.options.find((option) => option.key === (selected.key === 'Dual LM' ? 'Yes' : 'No'))
      }
    });
    if (selected.key === 'Dual LM') {
      setIsSecondaryVisible(true);
      setIsSecondaryActive(true);

      // delete lanIp/ wanIp keys from primary form.
      const filteredPrimaryForm = { ...primaryForm };

      if (filteredPrimaryForm.hasOwnProperty('lanIp')) {
        delete filteredPrimaryForm['lanIp'];
      }

      if (filteredPrimaryForm.hasOwnProperty('wanIp')) {
        delete filteredPrimaryForm['wanIp'];
      }

      setSecondaryForm({ ...secondaryForm, ...filteredPrimaryForm });
    } else {
      setIsSecondaryVisible(false);
    }
  };

  const onSecondaryChange = (selected) => {
    if (selected.formKey === 'qos') {
      onQosChange(selected, 'secondary');
      return;
    }

    setSecondaryForm({
      ...secondaryForm,
      [selected.formKey]: {
        ...secondaryForm[selected.formKey],
        value: selected
      }
    });

    // E-ILL CUTOVER CHANGE -> ROUTING PROTOCOL SHOULD BE SAME FOR BOTH LINKS -> VPN PRODUCT
    if (selected?.formKey === FORM_FIELDS.ROUTING_PROTOCOL) {
      setPrimaryForm({
        ...primaryForm,
        [selected.formKey]: { ...primaryForm[selected.formKey], value: selected }
      });
    }
  };

  const initForm = (reset = false) => {
    const bandwidths = getFromSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH);
    const leadStatus = reset ? false : selectedPlan && selectedPlan.specs ? true : checkLeadSatus();
    // const leadStatus = checkLeadSatus();
    const initFormPrimary = getDefaultValue(commercialAttributes, bandwidths, selectedPlan, leadStatus, 'PRIMARY', customerData);
    // setPrimaryForm(getQOSState(initFormPrimary, initFormPrimar(checkLeadSatus() || !isValid()) ?y.qos.value ));
    setPrimaryForm(initFormPrimary);

    const initFormSecondary = getDefaultValue(commercialAttributes, bandwidths, selectedPlan, leadStatus, 'SECONDARY', customerData);
    // setSecondaryForm(getQOSState(initFormSecondary, initFormSecondary.qos.value ));

    const filteredPrimaryForm = { ...initFormPrimary };

    if (filteredPrimaryForm.hasOwnProperty('lanIp')) {
      delete filteredPrimaryForm['lanIp'];
    }

    if (filteredPrimaryForm.hasOwnProperty('wanIp')) {
      delete filteredPrimaryForm['wanIp'];
    }

    setSecondaryForm({ ...initFormSecondary, ...filteredPrimaryForm });

    setDefaultState(primaryForm);
    const secondaryLink = initFormPrimary.lastMile && initFormPrimary.lastMile.value && initFormPrimary.lastMile.value.key === 'Dual LM' ? true : false;
    // console.log('primaryForm', primaryForm)
    // console.log('SecondaryForm', secondaryForm)
    setIsSecondaryActive(secondaryLink);
    setIsSecondaryVisible(secondaryLink);
    changeIpAttribute(initFormPrimary, initFormSecondary);
    setIsFormInitilaised(true);
  };

  useEffect(() => {
    if (currentPlan.speed !== selectedPlan.speed) {
      initForm();
    }
    loadCustomerData();
  }, [selectedPlan]);

  useEffect(() => {
    if (checkLeadSatus() || (selectedPlan && selectedPlan.specs)) {
      initForm();
    }
    if (open) {
      setPrimaryMedia(selectedPrimaryMedia);
      trackAnalytics(faOnDedicatedKamPlanConfigurationModalLoad, faOnDedicatedPlanConfigurationModalLoad);
    }
    loadCustomerData();
  }, [open]);

  const onResetChange = () => {
    setPrimaryForm(getQOSState(defaultState, defaultState.qos));
    setSecondaryForm(getQOSState(defaultState, defaultState.qos));
  };

  const loadCustomerData = () => {
    // console.log('dualLastMile', dualLastMile)
    const customerDetailsFromSession = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
    // console.log('customerDetailsFromSession', customerDetailsFromSession)
    if (customerDetailsFromSession && customerDetailsFromSession.lastMile) {
      setCustomerData(customerDetailsFromSession);
      return;
    }

    const lastMile = ((dualLastMile && dualLastMile) || showOnlyOK) === true ? 'Dual LM' : 'Single LM';
    setCustomerData({ lastMile });

    // if(leadDetails && leadDetails.connectivityLineItems && leadDetails.connectivityLineItems.length
    //     && leadDetails.connectivityLineItems[0].feasibilityResponse
    //     && leadDetails.connectivityLineItems[0].feasibilityResponse){
    //     const lastMile = leadDetails.connectivityLineItems[0].feasibilityResponse.dualLastMile === true ? 'Dual LM' : 'Single LM';
    //     setCustomerData({lastMile});
    //     console.log('lastMile', lastMile)
    //     setTimeout(() => {
    //         console.log('setCustomerData', customerData)
    //     }, 3000)
    //     // return;
    // }
  };

  const onServiceChange = (selected, type) => {
    // if (type === 'secondary') {
    //   setSecondaryForm({
    //     ...secondaryForm,
    //     [selected.formKey]: {
    //       ...secondaryForm[selected.formKey],
    //       value: selected
    //     }
    //   });
    //   return;
    // }
    let filteredRoutingProtocol = primaryForm?.routingProtocol;

    if (selected?.id !== 'UNMANAGED') {
      filteredRoutingProtocol.options = filteredRoutingProtocol.options?.filter((item) => item.id !== 'None');
    } else {
      filteredRoutingProtocol.options = filteredRoutingProtocol.originalOptions;
    }

    filteredRoutingProtocol.value = filteredRoutingProtocol.options?.[0];

    setPrimaryForm({
      ...primaryForm,
      [selected.formKey]: { ...primaryForm[selected.formKey], value: selected },
      routingProtocol: filteredRoutingProtocol
    });
    setSecondaryForm({
      ...secondaryForm,
      [selected.formKey]: { ...secondaryForm[selected.formKey], value: selected },
      routingProtocol: filteredRoutingProtocol
    });
    // handle CPE - cpeType
    // if (selected?.id === 'UNMANAGED' || selected?.id === 'PARTIALLY_MANAGED') {
    //   setPrimaryForm({
    //     ...primaryForm,
    //     [selected.formKey]: { ...primaryForm[selected.formKey], value: selected },
    //     cpeType: {
    //       ...primaryForm.cpeType,
    //       value: {
    //         ...primaryForm.cpeType.value,
    //         displayName: 'None',
    //         id: 'None',
    //         key: 'None'
    //       }
    //     }
    //   });
    //   setSecondaryForm({
    //     ...secondaryForm,
    //     [selected.formKey]: { ...secondaryForm[selected.formKey], value: selected },
    //     cpeType: {
    //       ...secondaryForm.cpeType,
    //       value: {
    //         ...secondaryForm.cpeType.value,
    //         displayName: 'None',
    //         id: 'None',
    //         key: 'None'
    //       }
    //     }
    //   });
    // } else {
    //   setPrimaryForm({
    //     ...primaryForm,
    //     [selected.formKey]: { ...primaryForm[selected.formKey], value: selected },
    //     cpeType: {
    //       ...primaryForm.cpeType,
    //       value: primaryForm.cpeType?.options[0]
    //     }
    //   });
    //   setSecondaryForm({
    //     ...secondaryForm,
    //     [selected.formKey]: { ...secondaryForm[selected.formKey], value: selected },
    //     cpeType: {
    //       ...secondaryForm.cpeType,
    //       value: primaryForm.cpeType?.options[0]
    //     }
    //   });
    // }
  };

  // const onRedundancyChange = (selected) => {
  //   if (selected.id === 'No') {
  //     const bandwidths = getFromSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH);
  //     const initForm = getDefaultValue(commercialAttributes, bandwidths, selectedPlan, false, 'PRIMARY', customerData);
  //     const { lastMile, pop, cpeType, cloud } = initForm;
  //     setPrimaryForm({
  //       ...primaryForm,
  //       [selected.formKey]: {
  //         ...primaryForm[selected.formKey],
  //         value: selected
  //       },
  //       lastMile,
  //       pop,
  //       cpeType,
  //       cloud
  //     });
  //     setIsSecondaryVisible(false);
  //   } else {
  //     setPrimaryForm({
  //       ...primaryForm,
  //       [selected.formKey]: {
  //         ...primaryForm[selected.formKey],
  //         value: selected
  //       }
  //     });
  //   }
  // };

  const closeDrawer = () => {
    onResetChange();
    close(false);
  };

  const isValid = () =>
    isSecondaryVisible
      ? isFormValid(primaryForm, ['touched', 'commercial', 'formKey'], ['lanIp', 'wanIp']) &&
        isFormValid(secondaryForm, ['touched', 'commercial', 'formKey', 'business', 'prt', 'pnrt', 'standard'], ['lanIp_secondary', 'wanIp_secondary'])
      : isFormValid(primaryForm, ['touched', 'commercial', 'formKey'], ['lanIp', 'wanIp']);

  // const isValid = () =>
  //   isFormValid(primaryForm, ["touched", "commercial", "formKey"]);

  const saveAttributeData = () => {
    if (isValid()) {
      const specsData = prepareSpecModel(primaryForm, secondaryForm, isSecondaryVisible);

      console.log('specsData', specsData);

      setSelectedPrimaryMedia(primaryMedia);
      // set lanip/wanip for primary/secondary form
      const updatePrimaryIpDetails = () => {
        const primary_lan_ip =
          (Array.isArray(specsData) && specsData.length > 0 && specsData.find((item) => item.name === 'lanIp') && specsData.find((item) => item.name === 'lanIp').value) || '';
        const primary_wan_ip =
          (Array.isArray(specsData) && specsData.length > 0 && specsData.find((item) => item.name === 'wanIp') && specsData.find((item) => item.name === 'wanIp').value) || '';

        setInSessionStorage(MODULE_ID, VPN_CONFIG.PRIMARY_LAN_IP, primary_lan_ip);
        setInSessionStorage(MODULE_ID, VPN_CONFIG.PRIMARY_WAN_IP, primary_wan_ip);
      };

      const updateSecondaryIpDetails = () => {
        const secondary_lan_ip =
          (Array.isArray(specsData) &&
            specsData.length > 0 &&
            specsData.find((item) => item.name === 'lanIp_secondary') &&
            specsData.find((item) => item.name === 'lanIp_secondary').value) ||
          '';
        const secondary_wan_ip =
          (Array.isArray(specsData) &&
            specsData.length > 0 &&
            specsData.find((item) => item.name === 'wanIp_secondary') &&
            specsData.find((item) => item.name === 'wanIp_secondary').value) ||
          '';

        setInSessionStorage(MODULE_ID, VPN_CONFIG.SECONDARY_LAN_IP, secondary_lan_ip);
        setInSessionStorage(MODULE_ID, VPN_CONFIG.SECONDARY_WAN_IP, secondary_wan_ip);
      };

      if (isSecondaryVisible) {
        updateSecondaryIpDetails();
        updatePrimaryIpDetails();
      } else {
        updatePrimaryIpDetails();
      }

      updateDiConnectionData(specsData);
      setServiceOption(primaryForm.manageability.value);
      setservicetype(primaryForm.manageability.value.id);
      setDefaultState(primaryForm);
      setCurrentPlan(selectedPlan);
      changeIpAttribute(primaryForm, secondaryForm);
      close();
    } else {
      setShowErrorPopup({
        state: true,
        data: {
          title: 'Invalid Form',
          message: 'Please fill all the mandatory field',
          buttonYes: 'Ok Got It'
        }
      });
    }
    trackAnalytics(faOnDedicatedKamPlanConfigurationModalSubmit, faOnDedicatedPlanConfigurationModalSubmit);
  };

  const changeIpAttribute = (primaryFormData = null, secondaryFormData = null) => {
    let ipAttributeType = false;
    let attributeChanged = false;
    if (commercialAttributes && commercialAttributes.configAttributesMap) {
      const configAttrs = commercialAttributes.configAttributesMap;
      const formValues = primaryFormData ? primaryFormData : primaryForm;
      const frmContrlKeys = Object.keys(formValues);
      frmContrlKeys.forEach((cntrlKey) => {
        const configAttr = configAttrs[cntrlKey];
        if (configAttr && configAttr.commercial && configAttr.defaultValue && configAttr.defaultValue !== formValues[cntrlKey]?.value?.id) {
          ipAttributeType = true;
          // console.log('cntrlKey', cntrlKey, configAttr, formValues[cntrlKey])
          return;
        }
      });
      if (secondaryFormData) {
        const frmContrls = Object.keys({
          ...primaryFormData,
          ...secondaryFormData
        });
        frmContrls.forEach((cntrlKey) => {
          // console.log('configAttrs[cntrlKey]', cntrlKey, configAttrs[cntrlKey])
          const configAttr = configAttrs[cntrlKey];
          if (
            configAttr &&
            configAttr.defaultValue &&
            cntrlKey !== 'manageability' &&
            ((configAttr.defaultValue && primaryFormData[cntrlKey] && primaryFormData[cntrlKey].value && configAttr.defaultValue !== primaryFormData[cntrlKey].value.id) ||
              (configAttr.defaultValue && secondaryFormData[cntrlKey] && secondaryFormData[cntrlKey].value && configAttr.defaultValue !== secondaryFormData[cntrlKey].value.id))
          ) {
            attributeChanged = true;
            // console.log('attributeChangedCntrlKey', cntrlKey, configAttr, frmContrls[cntrlKey])
            return;
          }
        });
      }
    }

    changeIpAttributeType({
      ipAttributeType,
      speed: selectedPlan.speed,
      attributeChanged
    });
  };

  const resetToStandard = () => {
    initForm(true);
    changeIpAttributeType({
      ipAttributeType: false,
      speed: selectedPlan.speed,
      attributeChanged: false
    });
    // initForm(true);
  };

  const handleToggle = () => {
    setIsPrimaryActive(!isPrimaryActive);
  };

  const handleSecondaryToggle = () => {
    setIsSecondaryActive(!isSecondaryActive);
  };

  const onPortBandWidthChange = (selected, type) => {
    const form = type === 'secondary' ? secondaryForm : primaryForm;
    const setForm = type === 'secondary' ? setSecondaryForm : setPrimaryForm;
    const numericBandwidth = selected.id.toString().replace(' Mbps', '');
    if (form.qos.value.id === 'Multiple') {
      const sum = getSumOfInputBandwidths();
      const bandwidthErr = sum && sum > numericBandwidth ? [`Total sum should not be greater than portbandwidth(${numericBandwidth} Mbps)`] : [];
      // setForm({...form, [selected.formKey]: {...form[selected.formKey], value: selected},
      //                   [key]: {...form[key], errors: bandwidthErr}
      // });
      const formData = { ...form };
      formData[selected.formKey].value = selected;

      const secondaryFormData = { ...secondaryForm };
      secondaryFormData[selected.formKey].value = selected;
      validationKeysForQOS.forEach((frmCntrolKey) => {
        formData[frmCntrolKey].errors = bandwidthErr;
        secondaryFormData[frmCntrolKey].value = formData[frmCntrolKey].value;
      });
      setPrimaryForm(formData);
      setSecondaryForm(secondaryFormData);
      return;
    }
    setForm({
      ...form,
      business: {
        ...form.business,
        value: selected.id.toString().replace(' Mbps', '')
      },
      [selected.formKey]: { ...form[selected.formKey], value: selected }
    });
    setSecondaryForm({
      ...secondaryForm,
      [selected.formKey]: { ...form[selected.formKey], value: selected }
    });
  };

  const trackAnalytics = (kamEvent, customerEvent) => {
    if (paramsValue && paramsValue.user === 'KAM') {
      kamEvent && kamEvent();
    } else {
      customerEvent && customerEvent();
    }
  };

  const handleMediaTypeChange = (item) => {
    setPrimaryMedia(item);

    // update IP Version
    if (item?.key === MEDIA_TYPES.FOUR_G || item?.key === MEDIA_TYPES.FIVE_G) {
      setPrimaryForm({
        ...primaryForm,
        ipVersion: {
          ...primaryForm.ipVersion,
          options: primaryForm.ipVersion?.options?.filter((item) => item?.id !== 'IPV6' && item?.id !== 'Dual Stack')
        }
      });
    } else {
      setPrimaryForm({
        ...primaryForm,
        ipVersion: {
          ...primaryForm.ipVersion,
          options: primaryForm.ipVersion?.originalOptions
        }
      });
    }
  };

  const isMediaEmpty = () => {
    const isKam = paramsValue && paramsValue.user === 'KAM';

    if (!isKam && (isSiteManualFeasible || isSitePendingThirdParty)) {
      return false;
    }

    return Object.keys(primaryMedia).length === 0;
  };

  return (
    <React.Fragment>
      {isFormInitilaised && open && (
        <div className={`drawer_container ${open ? 'active' : ''}`}>
          <div className="drawer">
            <div className="drawer_header">
              <div className="container">
                <div className="drawer_head">
                  <div className="title_info">
                    <h4 className="title_heading">Plan Configuration</h4>
                  </div>
                  <span className="close_icon" onClick={closeDrawer}></span>
                </div>
              </div>
            </div>
            <div className="drawer_body">
              <div className="scroll_content">
                <div className="container">
                  <div className="config_info">
                    <div className="info_title">
                      <span className="material-icons-outlined">settings</span>
                      {/* <h5>All the plans have a default configuration with managed services and standard IP attributes. You may customise the plans by changing the values below. {ipAttributeType && <span className="color-red" onClick={()=>setDefaultAttributeList(commercialAttribute)}>Reset To Standard configuration</span>}  </h5> */}
                      <h5>
                        {' '}
                        {ipAttributeType && !checkLeadSatus()
                          ? 'You have customised your plan. Do you want standard configuration instead? '
                          : 'All the plans have a default configuration with managed services and standard IP attributes. You may customise the plans by changing the values below. '}{' '}
                        {ipAttributeType && !checkLeadSatus() && (
                          <span className="color-red" onClick={() => resetToStandard()}>
                            Reset To Standard configuration
                          </span>
                        )}{' '}
                      </h5>
                    </div>
                    <p>Additional charges may apply in case of Non-Standard IP attributes.</p>
                  </div>
                  <div className={` ${'accordion_group'} ${isPrimaryActive ? 'active' : ''}`}>
                    <div className="accodion_head_title">
                      <h6>PRIMARY LINK</h6> <span className="animatedarrow" onClick={handleToggle}></span>
                    </div>
                    <div className="accordion_detialed_info">
                      <div className="config_form">
                        {showErrorPopup.state ? <PopupComponent toggleSelectPopUp={toggleSelectPopUp} popupData={showErrorPopup.data} /> : ''}
                        <div className="select_info">
                          <div className="text">Redundancy</div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">
                                <p>
                                  Choose “<strong>No</strong>” for only single link and “<strong>Yes</strong>” for multiple links (Primary and Secondary links).{' '}
                                </p>
                                <ul className="tooltip_list">
                                  <li>
                                    You may choose <strong>Dual Last Mile</strong> for both Primary and Secondary links in order to maintain high uptime SLA.
                                  </li>
                                  <li>
                                    Choose <strong>Dual POP</strong> for connectivity at your location for 2 different Point of Presence(POP).
                                  </li>
                                  <li>
                                    Choose <strong>Dual Cloud</strong> for using both Airtel Cloud and Third Party Cloud,
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="radio_box">
                          <RadioGroup
                            options={primaryForm.redundancy && primaryForm.redundancy.options}
                            value={primaryForm.redundancy && primaryForm.redundancy.value}
                            // onChange={onRedundancyChange}
                            disabled
                          />
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            {customerData && customerData.lastMile === 'Dual LM' ? (
                              <Select
                                label="Last Mile"
                                value={primaryForm.lastMile && primaryForm.lastMile.value}
                                onChange={onLastMileChange}
                                options={primaryForm.lastMile.options}
                                placeholder="Last Mile"
                                required
                              />
                            ) : (
                              <Input
                                label="Last Mile"
                                value={primaryForm.lastMile && primaryForm.lastMile.value && primaryForm.lastMile.value.displayName}
                                disabled={true}
                                required
                              />
                            )}
                          </div>
                        </div>
                        <div className="select_info">
                          <div className="text">
                            <span className="material-icons">info</span> All the attributes for secondary link is same as primary link{' '}
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            {primaryForm.redundancy && primaryForm.redundancy.value && primaryForm.redundancy.value.id === 'Yes' ? (
                              <Select
                                label="POP"
                                value={primaryForm.pop && primaryForm.pop.value}
                                onChange={onPrimaryChange}
                                options={primaryForm.pop.options}
                                placeholder="POP"
                                required
                              />
                            ) : (
                              <Input label="POP" value={primaryForm.pop && primaryForm.pop.value && primaryForm.pop.value.displayName} disabled={true} required />
                            )}
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            {primaryForm.redundancy && primaryForm.redundancy.value && primaryForm.redundancy.value.id === 'Yes' ? (
                              <Select
                                label="CPE"
                                value={primaryForm.cpeType && primaryForm.cpeType.value}
                                onChange={onCPEChange}
                                options={primaryForm.cpeType.options}
                                placeholder="CPE"
                                required
                              />
                            ) : (
                              <Input label="CPE" value={primaryForm.cpeType && primaryForm.cpeType.value && primaryForm.cpeType.value.displayName} disabled={true} required />
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            {primaryForm.redundancy && primaryForm.redundancy.value && primaryForm.redundancy.value.id === 'Yes' ? (
                              <Select
                                label="Cloud"
                                value={primaryForm.cloud && primaryForm.cloud.value}
                                onChange={onPrimaryChange}
                                options={primaryForm.cloud.options}
                                placeholder="Cloud"
                                required
                              />
                            ) : (
                              <Input label="Cloud" value={primaryForm.cloud && primaryForm.cloud.value && primaryForm.cloud.value.displayName} disabled={true} required />
                            )}
                          </div>
                        </div>

                        <div className="select_info">
                          <div className="text">Media Type </div>
                        </div>

                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="Media Type"
                              value={primaryMedia}
                              onChange={handleMediaTypeChange}
                              options={primaryMediaOptions}
                              placeholder="Media Type"
                              required
                              disabled={isSiteManualFeasible || isSitePendingThirdParty}
                            />
                            {primaryMedia && primaryMedia.key === MEDIA_TYPES.OFFNET && (
                              <div className="text" style={{ position: 'relative', top: '-15px' }}>
                                <span className="material-icons-outlined">info</span>
                                Additional CAPEX charges may apply
                              </div>
                            )}
                            {primaryMedia && primaryMedia.key === MEDIA_TYPES.THIRD_PARTY && (
                              <div className="text" style={{ position: 'relative', top: '-15px' }}>
                                <span className="material-icons-outlined">info</span>
                                Additional Third Party charges may apply
                              </div>
                            )}
                            {isRFMedia(primaryMedia?.key) && (
                              <div className="text" style={{ position: 'relative', top: '-15px' }}>
                                Pole/Tower Height - {`${primaryMedia?.towerHeight} (Probability - 80%)` || '-'}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="select_info">
                          <div className="text">Bandwidth </div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">
                                <p>Please note that Port Bandwidth will always be less than or equal to Access Bandwidth.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="Port Bandwidth"
                              value={primaryForm.portBandwidth && primaryForm.portBandwidth.value}
                              onChange={onPortBandWidthChange}
                              options={primaryForm.portBandwidth && primaryForm.portBandwidth.options}
                              placeholder="Port Bandwidth"
                              required
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input label="Access Bandwidth" value={primaryForm.accessBandwidth && primaryForm.accessBandwidth.value} disabled={true} required />
                          </div>
                        </div>
                        <div className="select_info">
                          <div className="text">Service Type </div>
                          {/* {
                                                    primaryForm.serviceType.value.id === 'MANAGED' && */}
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined" onMouseOver={() => setShowManageServices(true)} onClick={() => setShowManageServices(!showManageServices)}>
                              info
                            </span>
                            {showManageServices && <ServicesDropdown setShowManageServices={setShowManageServices} />}
                          </div>
                          {/* } */}
                        </div>
                        <div className="radio_box">
                          <RadioGroup
                            options={primaryForm.manageability && primaryForm.manageability.options}
                            value={primaryForm.manageability && primaryForm.manageability.value}
                            onChange={onServiceChange}
                          />
                        </div>
                        <div className="select_info">
                          <div className="text">Internet Protocol (IP) Attributes </div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">
                                <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                                <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="IP Version"
                              value={primaryForm.ipVersion && primaryForm.ipVersion.value}
                              onChange={onPrimaryChange}
                              options={primaryForm.ipVersion && primaryForm.ipVersion.options}
                              placeholder="IP Version"
                              required
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="Routing Protocol"
                              value={primaryForm.routingProtocol && primaryForm.routingProtocol.value}
                              onChange={onPrimaryChange}
                              options={primaryForm.routingProtocol && primaryForm.routingProtocol.options}
                              placeholder="Routing Protocol"
                              required
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="Quality of Service"
                              value={primaryForm.qos && primaryForm.qos.value}
                              onChange={onPrimaryChange}
                              options={primaryForm.qos && primaryForm.qos.options}
                              placeholder="Quality of Service"
                              required
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              label="Business (Mbps)"
                              required
                              maxlength={5}
                              value={primaryForm.business && primaryForm.business.value}
                              onBlur={() => onFieldBlur(primaryForm.business, 'business')}
                              errors={primaryForm.business && primaryForm.business.errors}
                              touched={primaryForm.business && primaryForm.business.touched}
                              onChange={(value) => onPrimaryChangeForInput(value, 'business')}
                              disabled={primaryForm.business && primaryForm.business.disabled}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              label="Standard (Mbps)"
                              required
                              maxlength={5}
                              value={primaryForm.standard && primaryForm.standard.value}
                              onBlur={() => onFieldBlur(primaryForm.standard, 'standard')}
                              errors={primaryForm.standard && primaryForm.standard.errors}
                              touched={primaryForm.standard && primaryForm.standard.touched}
                              onChange={(value) => onPrimaryChangeForInput(value, 'standard')}
                              disabled={primaryForm.standard && primaryForm.standard.disabled}
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              label="PRT (Mbps)"
                              required
                              maxlength={5}
                              value={primaryForm.prt && primaryForm.prt.value}
                              onBlur={() => onFieldBlur(primaryForm.prt, 'prt')}
                              errors={primaryForm.prt && primaryForm.prt.errors}
                              touched={primaryForm.prt && primaryForm.prt.touched}
                              onChange={(value) => onPrimaryChangeForInput(value, 'prt')}
                              disabled={primaryForm.prt && primaryForm.prt.disabled}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              label="PNRT (Mbps)"
                              maxlength={5}
                              value={primaryForm.pnrt && primaryForm.pnrt.value}
                              onBlur={() => onFieldBlur(primaryForm.pnrt, 'pnrt')}
                              errors={primaryForm.pnrt && primaryForm.pnrt.errors}
                              touched={primaryForm.pnrt && primaryForm.pnrt.touched}
                              onChange={(value) => onPrimaryChangeForInput(value, 'pnrt')}
                              disabled={primaryForm.pnrt && primaryForm.pnrt.disabled}
                              required
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              label="LAN IP"
                              value={primaryForm.lanIp && primaryForm.lanIp.value}
                              onBlur={() => onFieldBlur(primaryForm.lanIp, 'lanIp')}
                              errors={primaryForm.lanIp && primaryForm.lanIp.errors}
                              touched={primaryForm.lanIp && primaryForm.lanIp.touched}
                              onChange={(value) => onPrimaryChangeForInput(value, 'lanIp')}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Input
                              label="WAN IP"
                              value={primaryForm.wanIp && primaryForm.wanIp.value}
                              onBlur={() => onFieldBlur(primaryForm.wanIp, 'wanIp')}
                              errors={primaryForm.wanIp && primaryForm.wanIp.errors}
                              touched={primaryForm.wanIp && primaryForm.wanIp.touched}
                              onChange={(value) => onPrimaryChangeForInput(value, 'wanIp')}
                            />
                          </div>
                        </div>
                        <div className="select_info">
                          <div className="text">VPN </div>
                          <div className="tooltip_wrap">
                            <span className="material-icons-outlined">info</span>
                            <div className="tooltip">
                              <div className="tooltip_content">
                                <p>Define IP Version (IPV4, IPV6 or Dual Stack) according to your requirement.</p>
                                <p>Also note that the sum of Business, Standard, PRT and PRNT bandwidth will be equal to Port Bandwidth.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="VPN Type"
                              value={primaryForm.vpnType && primaryForm.vpnType.value}
                              onChange={onPrimaryChange}
                              options={primaryForm.vpnType && primaryForm.vpnType.options}
                              placeholder="VPN Type"
                              required
                            />
                          </div>
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="VPN Topology"
                              value={primaryForm.vpnTopology && primaryForm.vpnTopology.value}
                              onChange={(selected) => onVPNTopologyChange(selected, primaryForm, setPrimaryForm)}
                              options={primaryForm.vpnTopology && primaryForm.vpnTopology.options}
                              placeholder="VPN Topology"
                              required
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="flg-lg-6 flg-md-6">
                            <Select
                              label="Link Topology"
                              value={primaryForm.linkTopology && primaryForm.linkTopology.value}
                              onChange={onPrimaryChange}
                              options={primaryForm.linkTopology && primaryForm.linkTopology.options}
                              placeholder="Link Topology"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isSecondaryVisible && (
                    <div className={` ${'accordion_group'} ${isSecondaryActive ? 'active' : ''}`}>
                      <div className="accodion_head_title">
                        <h6>SECONDARY LINK</h6> <span className="animatedarrow" onClick={handleSecondaryToggle}></span>
                      </div>
                      <div className="accordion_detialed_info">
                        <div className="config_form">
                          <div className="select_info">
                            <div className="text">Media Type </div>
                          </div>

                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="Media Type"
                                value={isSiteManualFeasible || isSitePendingThirdParty ? {} : { id: 'Third Party', key: 'Third Party', displayName: 'Third Party' }}
                                options={[]}
                                placeholder="Media Type"
                                disabled
                                required
                              />
                            </div>
                          </div>

                          <div className="select_info">
                            <div className="text">Bandwidth </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="Port Bandwidth"
                                value={secondaryForm.portBandwidth && secondaryForm.portBandwidth.value}
                                onChange={(selected) => onPortBandWidthChange(selected, 'secondary')}
                                options={secondaryForm.portBandwidth && secondaryForm.portBandwidth.options}
                                placeholder="Port Bandwidth"
                                disabled={true}
                                required
                              />
                            </div>
                            <div className="flg-lg-6 flg-md-6">
                              <Input label="Access Bandwidth" value={secondaryForm.accessBandwidth && secondaryForm.accessBandwidth.value} disabled={true} required />
                            </div>
                          </div>
                          <div className="select_info">
                            <div className="text">Service Type </div>
                          </div>
                          <div className="radio_box">
                            <RadioGroup
                              options={secondaryForm.manageability && secondaryForm.manageability.options}
                              value={secondaryForm.manageability && secondaryForm.manageability.value}
                              onChange={(value) => onServiceChange(value, 'secondary')}
                              //    disabled = {true}
                            />
                          </div>
                          <div className="select_info">
                            <div className="text">Bandwidth </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="IP Version"
                                value={secondaryForm.ipVersion && secondaryForm.ipVersion.value}
                                onChange={onSecondaryChange}
                                options={secondaryForm.ipVersion && secondaryForm.ipVersion.options}
                                placeholder="IP Version"
                                required
                              />
                            </div>
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="Routing Protocol"
                                value={secondaryForm.routingProtocol && secondaryForm.routingProtocol.value}
                                onChange={onSecondaryChange}
                                options={secondaryForm.routingProtocol && secondaryForm.routingProtocol.options}
                                placeholder="Routing Protocol"
                                required
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="Quality of Service"
                                value={primaryForm.qos && primaryForm.qos.value}
                                onChange={onSecondaryChange}
                                options={secondaryForm.qos && secondaryForm.qos.options}
                                placeholder="Quality of Service"
                                disabled={true}
                                required
                              />
                            </div>
                            <div className="flg-lg-6 flg-md-6">
                              <Input label="Business (Mbps)" disabled={true} required maxlength={5} value={primaryForm.business && primaryForm.business.value} />
                            </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Input label="Standard (Mbps)" disabled={true} required maxlength={5} value={primaryForm.standard && primaryForm.standard.value} />
                            </div>
                            <div className="flg-lg-6 flg-md-6">
                              <Input label="PRT (Mbps)" required disabled={true} maxlength={5} value={primaryForm.prt && primaryForm.prt.value} />
                            </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Input label="PNRT (Mbps)" maxlength={5} disabled={true} value={primaryForm.pnrt && primaryForm.pnrt.value} />
                            </div>
                            <div className="flg-lg-6 flg-md-6">
                              <Input
                                label="LAN IP"
                                value={secondaryForm.lanIp_secondary && secondaryForm.lanIp_secondary.value}
                                onBlur={() => onFieldBlur(secondaryForm.lanIp_secondary, 'lanIp_secondary', 'secondary')}
                                errors={secondaryForm.lanIp_secondary && secondaryForm.lanIp_secondary.errors}
                                touched={secondaryForm.lanIp_secondary && secondaryForm.lanIp_secondary.touched}
                                onChange={(value) => onPrimaryChangeForInput(value, 'lanIp_secondary', 'secondary')}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Input
                                label="WAN IP"
                                value={secondaryForm.wanIp_secondary && secondaryForm.wanIp_secondary.value}
                                onBlur={() => onFieldBlur(secondaryForm.wanIp_secondary, 'wanIp_secondary', 'secondary')}
                                errors={secondaryForm.wanIp_secondary && secondaryForm.wanIp_secondary.errors}
                                touched={secondaryForm.wanIp_secondary && secondaryForm.wanIp_secondary.touched}
                                onChange={(value) => onPrimaryChangeForInput(value, 'wanIp_secondary', 'secondary')}
                              />
                            </div>
                          </div>
                          <div className="select_info">
                            <div className="text">VPN </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="VPN Type"
                                value={secondaryForm.vpnType && secondaryForm.vpnType.value}
                                onChange={onSecondaryChange}
                                options={secondaryForm.vpnType && secondaryForm.vpnType.options}
                                placeholder="VPN Type"
                                required
                              />
                            </div>
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="VPN Topology"
                                value={secondaryForm.vpnTopology && secondaryForm.vpnTopology.value}
                                onChange={(selected) => onVPNTopologyChange(selected, secondaryForm, setSecondaryForm)}
                                options={secondaryForm.vpnTopology && secondaryForm.vpnTopology.options}
                                placeholder="VPN Topology"
                                required
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="flg-lg-6 flg-md-6">
                              <Select
                                label="Link Topology"
                                value={secondaryForm.linkTopology && secondaryForm.linkTopology.value}
                                onChange={onSecondaryChange}
                                options={secondaryForm.linkTopology && secondaryForm.linkTopology.options}
                                placeholder="Link Topology"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="drawer_footer">
              <div className="container">
                <div className="button_group">
                  {!showOnlyOK && (
                    <React.Fragment>
                      <Button variant="outlinebtn" onClick={() => closeDrawer()}>
                        Cancel
                      </Button>
                      {checkLeadSatus() || !isValid() || isMediaEmpty() ? (
                        <Button variant="outlinebtn" disabled>
                          Save
                        </Button>
                      ) : (
                        <Button onClick={saveAttributeData}>Save</Button>
                      )}
                    </React.Fragment>
                  )}
                  {/* {showOnlyOK && (
                    <Button variant="outlinebtn" onClick={() => closeDrawer()}>
                      Close
                    </Button>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default PlanConfigurationForMPLS;
